module.exports = __webpack_public_path__ + "media/bensound-tomorrow.63cc0a84.mp3";